import { useState } from "react";
import {
  ListBase,
  useListContext,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { addTags } from "../../../../Utils/QuoteRequestUtils";
import { Add } from "@mui/icons-material";
import { Box, Button, Menu, MenuItem, MenuList } from "@mui/material";

const AddTagButton = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isAdmin = localStorage.getItem("permissions")?.includes("ROLE_ADMIN");

  const handleSubmit = async (tagId) => {
    try {
      const result = await addTags({ quoteId: record["@id"], tag: [tagId] });
      setAnchorEl(null);
      result.status === "success"
        ? refresh()
        : notify(result.error, { type: "error" });
    } catch (e) {
      notify(e.message || "Error adding tag", { type: "error" });
    }
  };

  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const TagList = () => {
    const { data } = useListContext();
    if (!data || !record) return null;

    const visibleTags = data.filter((tag) => !tag.hidden || isAdmin);

    return (
      <MenuList variant="selectedMenu">
        {visibleTags.map((tag, i) => {
          const isDisabled = record.tags.some(
            (quoteTag) => quoteTag["@id"] === tag["@id"]
          );
          if (tag.tagName === "NO COVERAGE" && !isAdmin) {
            return null;
          }
          return (
            <MenuItem
              key={i}
              disabled={isDisabled}
              dense
              onClick={() => handleSubmit(tag["@id"])}
            >
              {tag.tagName}
            </MenuItem>
          );
        })}
      </MenuList>
    );
  };

  return (
    <>
      <Box>
        <Button
          startIcon={<Add />}
          onClick={handleClick}
          variant="text"
          sx={{ m: 0, whiteSpace: "nowrap" }}
        >
          Add Tag
        </Button>
      </Box>
      <Menu
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        id="tag-menu"
      >
        <ListBase emptyWhileLoading resource="tags" perPage={100}>
          <TagList />
        </ListBase>
      </Menu>
    </>
  );
};

export default AddTagButton;
